"use client";

import type { IModuleBazaarvoiceGallery } from "@contentful-api/types/contentful";
import type { IModuleRenderedProps } from "@lib/contentful/modules-renderer/ModuleCreator";
import { Box } from "@ui/components/layout/box/Box";
import { useLocale } from "next-intl";

import { useEffect, type FC } from "react";

export interface IBazaarvoiceGalleryContainerProps
    extends IModuleRenderedProps<IModuleBazaarvoiceGallery> {}

export const BazaarvoiceGalleryContainer: FC<IBazaarvoiceGalleryContainerProps> = ({ module }) => {
    const { filter, galleryId } = module.fields ?? {};

    const locale = useLocale();

    useEffect(() => {
        if (!galleryId) return;
        const crl8 = window.crl8;
        if (crl8?.ready) {
            crl8.ready(async function () {
                if (crl8?.getAllExperiences) {
                    const allExperiences = await crl8.getAllExperiences();
                    const currentExperience = allExperiences
                        .filter((it) => it.isMounted)
                        .find((it) => it?.options?.containerId === galleryId);
                    if (currentExperience) {
                        crl8?.destroyExperience && (await crl8.destroyExperience(galleryId));
                    }
                    crl8?.createExperience && (await crl8.createExperience(galleryId));
                }
            });
        }
    }, [galleryId]);

    if (!galleryId) {
        return <></>;
    }

    return (
        <Box
            data-crl8-container-id={galleryId}
            data-crl8-locale={locale}
            data-crl8-filter={filter}
        ></Box>
    );
};

export default BazaarvoiceGalleryContainer;
